export default ['#ff1900', '#f57c00', '#7cb342']
